var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconQuality(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3565_4628)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M44.4591 28.0421V19.954H40.6878C40.265 18.2014 39.5762 16.5578 38.6555 15.0575L41.322 12.391L35.6003 6.66929L32.9338 9.33578C31.4335 8.42195 29.7899 7.72634 28.0373 7.30352V3.53906H19.9491V7.31034C18.1965 7.73316 16.553 8.42195 15.0526 9.3426L12.3861 6.67611L6.67125 12.391L9.33774 15.0575C8.4239 16.5578 7.72829 18.2014 7.30548 19.954H3.54102V28.0421H7.3123C7.73511 29.7948 8.4239 31.4383 9.34456 32.9387L6.67807 35.6052L12.3998 41.3269L15.0663 38.6604C16.5666 39.5742 18.2101 40.2698 19.9628 40.6926V44.4639H28.0509V40.6926C29.8036 40.2698 31.4471 39.581 32.9474 38.6604L35.6139 41.3269L41.3356 35.6052L38.6692 32.9387C39.583 31.4383 40.2786 29.7948 40.7014 28.0421H44.4727H44.4591Z",
    stroke: "#85C11F",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24 35.4571C30.3276 35.4571 35.4571 30.3276 35.4571 24C35.4571 17.6725 30.3276 12.543 24 12.543C17.6725 12.543 12.543 17.6725 12.543 24C12.543 30.3276 17.6725 35.4571 24 35.4571Z",
    stroke: "#85C11F",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.0415 19.3086L22.4586 24.1369L20.1195 21.7705L17.7599 24.2188L22.4791 29.0539L29.4283 21.5727L27.0415 19.3086Z",
    stroke: "#85C11F",
    strokeMiterlimit: 10
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3565_4628"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 41.6,
    height: 41.6,
    fill: "white",
    transform: "translate(3.19995 3.19922)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconQuality);
export default __webpack_public_path__ + "static/media/icon-quality.2530fa52b6783fb16f356fe48bc63dcb.svg";
export { ForwardRef as ReactComponent };